<div class="chip-list sp-pl-2" #content [class.chip-list-visible]="isExpanded">
  <ng-content></ng-content>
  <button class="sp-mr-8" *ngIf="isOverflowing && !isExpanded" [ngStyle]="{ order: viewMoreButtonOrder }" (click)="toggleContent()" ui-button uiShape="round" uiType="link" uiSize="small">
    {{ "view_more" | localize }}
  </button>
  <button class="sp-mr-8" *ngIf="isOverflowing && isExpanded" [ngStyle]="{ order: numberOfElements }" (click)="toggleContent()" ui-button uiShape="round" uiType="link" uiSize="small">
    {{ "view_less" | localize }}
  </button>
</div>
